<template>
  <div id="mbti" class="mbti mx-auto blue_bg">
    <router-link :to="{ name: 'index' }" class="justify-end hidden md:flex p-2">
      <img src="~@/assets/images/2024MBTI/logo.png" class="object-contain">
    </router-link>
    <div class="banner">
      <img src="~@/assets/images/2024MBTI/head.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/2024MBTI/headM.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="mb-5">
      <img src="~@/assets/images/2024MBTI/C1.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/2024MBTI/C1TM.png" class="object-contain mx-auto md:hidden mb-5">
      <img src="~@/assets/images/2024MBTI/C1M.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="flex flex-wrap max-w-5xl mx-auto mb-5">
      <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="item w-1/2 md:w-1/3 p-2" v-for="(item, index) in bookData" :key="index">
        <img :src="item.img_url" class="object-contain mx-auto">
      </router-link>
    </div>
    <div class="mb-5">
      <img src="~@/assets/images/2024MBTI/C2.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/2024MBTI/C2M.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="flex flex-wrap max-w-5xl mx-auto mb-5">
      <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="item w-1/2 md:w-1/3 p-2" v-for="(item, index) in bookData2" :key="index">
        <img :src="item.img_url" class="object-contain mx-auto">
      </router-link>
    </div>
    <div class="mb-5">
      <img src="~@/assets/images/2024MBTI/C3.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/2024MBTI/C3M.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="flex flex-wrap max-w-5xl mx-auto mb-5">
      <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="item w-1/2 md:w-1/3 p-2" v-for="(item, index) in bookData3" :key="index">
        <img :src="item.img_url" class="object-contain mx-auto">
      </router-link>
    </div>
    <div class="mb-5">
      <img src="~@/assets/images/2024MBTI/C4.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/2024MBTI/C4M.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="flex flex-wrap max-w-5xl mx-auto mb-5">
      <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="item w-1/2 md:w-1/3 p-2" v-for="(item, index) in bookData4" :key="index">
        <img :src="item.img_url" class="object-contain mx-auto">
      </router-link>
    </div>

    <div class="footer">
      <router-link :to="{ name: 'index' }" class="block">
        <img src="~@/assets/images/2024MBTI/foot.png" class="object-contain mx-auto">
      </router-link>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'mbti',
  metaInfo () {
    return {
      title: '用MBTI找出最適合你的語言學習法！任選2本75折',
      titleTemplate: null
    }
  },
  data () {
    return {
      bookData: [
        { id: 9682, img_url: require('@/assets/images/2024MBTI/b01/01.png') },
        { id: 8588, img_url: require('@/assets/images/2024MBTI/b01/02.png') },
        { id: 8461, img_url: require('@/assets/images/2024MBTI/b01/03.png') },
        { id: 8465, img_url: require('@/assets/images/2024MBTI/b01/04.png') },
        { id: 8009, img_url: require('@/assets/images/2024MBTI/b01/05.png') },
        { id: 7496, img_url: require('@/assets/images/2024MBTI/b01/06.png') }
      ],
      bookData2: [
        { id: 9958, img_url: require('@/assets/images/2024MBTI/b02/01.png') },
        { id: 7873, img_url: require('@/assets/images/2024MBTI/b02/02.png') },
        { id: 9317, img_url: require('@/assets/images/2024MBTI/b02/03.png') },
        { id: 8463, img_url: require('@/assets/images/2024MBTI/b02/04.png') },
        { id: 9389, img_url: require('@/assets/images/2024MBTI/b02/05.png') },
        { id: 8150, img_url: require('@/assets/images/2024MBTI/b02/06.png') }
      ],
      bookData3: [
        { id: 10181, img_url: require('@/assets/images/2024MBTI/b03/01.png') },
        { id: 8742, img_url: require('@/assets/images/2024MBTI/b03/02.png') },
        { id: 9440, img_url: require('@/assets/images/2024MBTI/b03/03.png') },
        { id: 8134, img_url: require('@/assets/images/2024MBTI/b03/04.png') },
        { id: 7399, img_url: require('@/assets/images/2024MBTI/b03/05.png') },
        { id: 7801, img_url: require('@/assets/images/2024MBTI/b03/06.png') }
      ],
      bookData4: [
        { id: 10235, img_url: require('@/assets/images/2024MBTI/b04/01.png') },
        { id: 8738, img_url: require('@/assets/images/2024MBTI/b04/02.png') },
        { id: 9534, img_url: require('@/assets/images/2024MBTI/b04/03.png') },
        { id: 8166, img_url: require('@/assets/images/2024MBTI/b04/04.png') },
        { id: 8926, img_url: require('@/assets/images/2024MBTI/b04/05.png') },
        { id: 10235, img_url: require('@/assets/images/2024MBTI/b04/06.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mbti {
  background-color: #fff0e8;
}
.blue_bg {
  background-image: url('~@/assets/images/2024MBTI/bg1.png'), url('~@/assets/images/2024MBTI/bg2.png'), url('~@/assets/images/2024MBTI/bg3.png');
  background-position: top left, center left, bottom left;
  background-repeat: no-repeat;
  background-size: contain;
  @media (max-width: 640px) {
    background-image: url('~@/assets/images/2024MBTI/bgM00.png'), url('~@/assets/images/2024MBTI/bgM01.png'), url('~@/assets/images/2024MBTI/bgM02.png'), url('~@/assets/images/2024MBTI/bgM03.png'), url('~@/assets/images/2024MBTI/bgM04.png');
    background-position: top left, top 2% left, top 40% left, top 65% left, bottom left;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
